import { ACTIONS_OPTIONS } from "@/constants/accessControl";
import { REQUEST_STATUS } from "@/constants/roles";

type OptionsMenu = {
  label: string;
  onlyEvaluatorAssigned: boolean;
  segcenAction: string;
  sectionsView: SectionsView[];
};

export type SectionsView = "TOP_TABLE" | "ROW_MENU_TABLE";

interface ActionsOptionMenu {
  [key: string]: OptionsMenu;
}


export const STATUS_COLOR_REQUIREMENTS = {
  [REQUEST_STATUS.IN_PROGRESS]: "text-brand-cyan-500 bg-brand-cyan-500/10",
  [REQUEST_STATUS.APPROVED]: "text-brand-cyan-500 bg-brand-cyan-500/10",
  [REQUEST_STATUS.CANCELED]: "text-gray-100 bg-gray-100/10",
  [REQUEST_STATUS.PENDING_REQUIREMENT]: "text-purple-500 bg-purple-500/10",
  [REQUEST_STATUS.REQUIREMENT_COMPLETED]: "text-blue-600 bg-blue-600/10",
  [REQUEST_STATUS.APPROVED_WITH_OBSERVATION]: "text-illustration-green-500 bg-illustration-green-500/10",
  [REQUEST_STATUS.REJECTED]: "text-brand-cyan-500 bg-brand-cyan-500/10",
  [REQUEST_STATUS.PENDING_SIGNATURE]: "text-orange-500 bg-orange-500/10",
  [REQUEST_STATUS.NEW_REQUIREMENT_COMPLETED]: "text-dark-gray bg-dark-gray/10",
  [REQUEST_STATUS.REVIEWED]: "text-illustration-orange-500 bg-illustration-orange-500/10"
}

export const configOptionAction: ActionsOptionMenu = {
  [ACTIONS_OPTIONS.addRequirement]: {
    label: "Agregar requisito",
    onlyEvaluatorAssigned: false,
    segcenAction: "",
    sectionsView: ["TOP_TABLE"]
  },
  [ACTIONS_OPTIONS.view_requirement]: {
    label: "Ver requisito",
    onlyEvaluatorAssigned: false,
    segcenAction: "007",
    sectionsView: ["ROW_MENU_TABLE"]
  },
  [ACTIONS_OPTIONS.endorsement]: {
    label: "Carta de endoso",
    onlyEvaluatorAssigned: true,
    segcenAction: "006",
    sectionsView: ["ROW_MENU_TABLE"]
  },
  [ACTIONS_OPTIONS.uploadImage]: {
    label: "Subir imagen",
    onlyEvaluatorAssigned: true,
    segcenAction: "006",
    sectionsView: ["TOP_TABLE"]
  },
  [ACTIONS_OPTIONS.realize]: {
    label: "Realizar",
    onlyEvaluatorAssigned: true,
    segcenAction: "005",
    sectionsView: ["TOP_TABLE"]
  },
  [ACTIONS_OPTIONS.annular]: {
    label: "Anular",
    onlyEvaluatorAssigned: true,
    segcenAction: "004",
    sectionsView: ["ROW_MENU_TABLE"]
  },
  [ACTIONS_OPTIONS.edit]: {
    label: "Editar",
    onlyEvaluatorAssigned: true,
    segcenAction: "003",
    sectionsView: ["ROW_MENU_TABLE"]
  }
}